const styles = {
  container: {
    width: '100%'
  },
  button: {
    marginBottom: '20px'
  },
  segments: {
    alignItems: 'center'
  }
}

export default styles
